module.exports = __webpack_public_path__ + "static/media/eop-220x440.82a55c6c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/app/images/adverts/eop-220x440.jpg
// module id = 65
// module chunks = 0